<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded-circle img-fluid"
                  />
                </div>
                <div class="name">
                  <h3 class="title">营养补品</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
              北极参、深海鳕鱼胶及西洋参是加拿大非常著名的营养补品特产。
              北极海参纯野生多年生长，Arctica Food 以及Ocean Feast是加拿大北极参著名高档品牌，品质极优。
              Ocean Feast 同品牌鱼胶及花旗参多年经营，赢得了众多代理商及客户的好评及信赖。
            </p>
          </div>
          <div class="profile-tabs">
            <tabs
              :tab-name="['海参', '花旗参', '鱼胶']"
              :tab-icon="['format_list_bulleted', 'format_list_bulleted', 'format_list_bulleted', 'format_list_bulleted']"
              plain
              nav-pills-icons
              color-button="primary"
            >
              <!-- here you can add your content for tab-content -->
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <ProductGallery :products="seaCucumberList" />
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <ProductGallery :products="ginsengList" />
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <ProductGallery :products="isinglassList" />
                </div>
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProductGallery from "@/components/products/ProductGallery.vue";
import { Tabs } from "@/components";
export default {
  name: "Seafood",
  components: {
    Tabs,
    ProductGallery
  },
  bodyClass: "profile-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bgs/underseaBG.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/faces/nutritionAvatar.jpeg")
    }
  },
  computed: {
    ...mapGetters(["products"]),
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    seaCucumberList() {
      return this.products.filter(item => item.product_category === 11);
    },
    ginsengList() {
      return this.products.filter(item => item.product_category === 10);
    },
    isinglassList() {
      return this.products.filter(item => item.product_category === 12);
    },
  },
  methods: {
    ...mapActions(["listProducts"])
  },
  mounted() {
    if (!this.products.length) {
      this.listProducts();
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs /deep/ {
  .md-card-tabs .md-list {
    justify-content: center;
  }
}

</style>
